import { useState } from 'react';
import { Completion, PEOPLE } from './types';
import { computeFairness, last30DaysDate } from './householdUtils';

interface FairnessPanelProps {
  completions: Completion[];
}

function FairnessPanel({ completions }: FairnessPanelProps) {
  const [range, setRange] = useState<'all' | '30'>('all');
  const totals = computeFairness(completions, range === '30' ? last30DaysDate() : undefined);
  const maxEffort = Math.max(1, ...PEOPLE.map((p) => totals.totalEffort[p]));

  const recent = [...completions]
    .sort((a, b) => b.completedAt.localeCompare(a.completedAt))
    .slice(0, 20);

  return (
    <div className="hh-fairness">
      <div className="hh-fairness-header">
        <h2>Fairness</h2>
        <div className="hh-range-toggle">
          <button
            type="button"
            className={`hh-btn hh-btn-small ${range === 'all' ? 'hh-btn-primary' : 'hh-btn-secondary'}`}
            onClick={() => setRange('all')}
          >
            All time
          </button>
          <button
            type="button"
            className={`hh-btn hh-btn-small ${range === '30' ? 'hh-btn-primary' : 'hh-btn-secondary'}`}
            onClick={() => setRange('30')}
          >
            Last 30 days
          </button>
        </div>
      </div>

      <div className="hh-fairness-bars">
        {PEOPLE.map((p) => (
          <div key={p} className="hh-fairness-row">
            <span className="hh-fairness-name">{p}</span>
            <div className="hh-fairness-bar-track">
              <div
                className="hh-fairness-bar-fill"
                style={{ width: `${(totals.totalEffort[p] / maxEffort) * 100}%` }}
              />
            </div>
            <span className="hh-fairness-value">
              {totals.totalEffort[p]}
              {' '}
              pts (
              {totals.completedCount[p]}
              {' '}
              done)
            </span>
          </div>
        ))}
      </div>

      <h3>Recent completions</h3>
      {recent.length === 0 && <p className="hh-empty">Nothing completed yet.</p>}
      <ul className="hh-list">
        {recent.map((c) => (
          <li key={c.id}>
            <span className="hh-list-title">{c.title}</span>
            <span className="hh-list-due">{c.completedAt.slice(0, 10)}</span>
            <span className="hh-list-assign">
              {c.assignee}
              {c.effort ? ` · ${c.effort}pt` : ''}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FairnessPanel;
